import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { Line } from "rc-progress";
import { Link } from "react-router-dom";
import SendingDialog from "../components/SendingDialog";
import { uploadAdminAsset } from "../utils/storageUpload";

function AddBenefit() {
  const [benefit, setBenefit] = useState({
    title: "",
    description: "",
  });
  const [fileURL, setFileURL] = useState();

  const [progress, setProgress] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadError("");
    try {
      const downloadURL = await uploadAdminAsset("benefit", file, {
        onProgress: (pct) => setProgress(pct),
      });
      setFileURL(downloadURL);
    } catch (error) {
      setUploadError(
        error instanceof Error ? error.message : "Upload failed. Try again."
      );
      setProgress(undefined);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsOpen(true);
    const fileUrl = fileURL;
    const title = benefit.title;
    const description = benefit.description;

    const post = { fileUrl, title, description };

    try {
      const res = await axios.post("/api/benefit", post);
      setIsOpen(false);
      alert(res.data.message);
      window.location.reload();
    } catch (error) {
      alert("Please make sure all fields have been filled out...");
      window.location.reload();
    }
  };

  return (
    <div className="h-[100vh]">
      <div className="flex h-[100%]">
        <Sidebar />
        <div className="md:w-[85%] w-[90%] flex items-center mx-auto md:mx-0 justify-center ">
          <form action="" className="md:w-[80%] w-[100%] flex flex-col gap-5">
            <input
              className="outline-none"
              type="file"
              accept="image/jpeg,image/png,image/gif,image/webp"
              onChange={handleChange}
            />
            {uploadError && (
              <p className="text-red-600 text-sm font-poppins">{uploadError}</p>
            )}
            {progress && (
              <div className="mx-auto flex items-center gap-2 justify-center mt-5">
                <Line
                  percent={progress}
                  strokeWidth={2}
                  strokeColor="#359602"
                  className="md:w-[100%] w-[80%]"
                />
                <span>{Math.floor(progress) + "%"}</span>
              </div>
            )}
            <div className="flex flex-col">
              <label htmlFor="">Title</label>
              <input
                className="px-3 py-1.5 border border-black outline-none"
                type="text"
                onChange={(e) =>
                  setBenefit({ ...benefit, title: e.target.value })
                }
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="">Description</label>
              <textarea
                className="px-3 py-1.5 border border-black outline-none"
                name=""
                id=""
                cols="30"
                rows="5"
                onChange={(e) =>
                  setBenefit({ ...benefit, description: e.target.value })
                }
              ></textarea>
            </div>
            <button
              onClick={(e) => handleSubmit(e)}
              className="border outline-none bg-[#359602] text-white font-plus font-bold text-lg py-3 w-[303px] px-3 rounded-[10px]"
            >
              Submit
            </button>
          </form>
          <SendingDialog isOpen={isOpen} setIsOpen={setIsOpen} />
          <Link to="/home">
            <button className=" md:hidden fixed bottom-5 right-2 bg-[#359602] text-white text-lg px-2 py-1 rounded-xl">
              Go to home
            </button>
          </Link>
          <Link to="/">
            <p className="text-black text-lg md:hidden top-16 right-2 fixed px-2 text-center py-1 bg-[#FFA500] border border-black rounded-xl cursor-pointer">
              Log out
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AddBenefit;
